// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "escola-de-habitos.firebaseapp.com",
  "projectId": "escola-de-habitos",
  "storageBucket": "escola-de-habitos.appspot.com",
  "messagingSenderId": "973422467359",
  "appId": "1:973422467359:web:5d3ffa2eb3f90e4f2d382a",
  "measurementId": "G-E0TS9WX9YH",
  "apiKey": "AIzaSyA2Ge3qPfsI439avPJbwJMEtzyCGbxfU0I"
};
